
export const SET_MR = "SET_CUSTOMER_DATA";
export const LOGOUT = "CLEAR_COMMON_STATE";
export const SET_BU_STATE_DETAILS = "SET_BU_STATE_DETAILS"
export const SET_NSM_STATE_DETAILS = "SET_NSM_STATE_DETAILS"

